<script>
  export let text;
</script>

<span class="badge">{text}</span>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 500;
    background: var(--accent);
    color: white;
    margin-right: 4px;
  }
</style>
